import { LinearProgress } from '@mui/material';

interface Props {
    top?: number;
}

export const PageLoader = ({ top = 66 }: Props) => (
    <LinearProgress
        sx={{
            position: 'fixed',
            top,
            left: 0,
            right: 0,
        }}
    />
);
